import {
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
  RequestModels_Products_Offers_OfferUsageSpecifiedEventRequestModel,
  RequestModels_Usages_Estimate_UsageEstimateRequestModel,
  ResponseModels_Usages_Estimate_UsageEstimateResponseModel,
} from '@monorepo-types/dc';

import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

type GetUsageEstimate = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  requestBody: RequestModels_Usages_Estimate_UsageEstimateRequestModel;
};
/**
 * Estimates the yearly energy usage for a household that does not know its own usage.
Usage values are null when no profile matches the answers.
 * 
 * @returns ResponseModels_Usages_Estimate_UsageEstimateResponseModel Success
 */
export function getUsageEstimate(
  { businessUnit, label, requestBody }: GetUsageEstimate,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_Usages_Estimate_UsageEstimateResponseModel> {
  return request(
    {
      method: 'POST',
      path: `/dxpweb/public/${businessUnit}/${label}/usage-estimates`,
      body: requestBody,
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}

type RecordOfferUsageSpecified = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  requestBody: RequestModels_Products_Offers_OfferUsageSpecifiedEventRequestModel;
};
/**
 * Receives the usages a customer specified, how they were obtained and the energy choice, once the
offers for them have loaded, and publishes them as an OfferUsageSpecified event.
 * 
 * @returns void 
 */
export function recordOfferUsageSpecified(
  { businessUnit, label, requestBody }: RecordOfferUsageSpecified,
  requestConfig: ApiRequestConfig = {},
): Promise<void> {
  return request(
    {
      method: 'POST',
      path: `/dxpweb/public/${businessUnit}/${label}/offers/usage-specified/events`,
      body: requestBody,
    },
    requestConfig,
  );
}
